import Snackbar from '@mui/material/Snackbar';
import Alert from '../bayer/alert';

const SnackbarAlert = ({
    children,
    openSnack,
    setOpenSnack,
    severity,
}: {
    children: React.ReactNode;
    openSnack: boolean;
    setOpenSnack: (open: boolean) => void;
    /** Matches `Alert`'s real `CustomSeverity` union -- it has no 'success'/'error'/'info'/'warning'. */
    severity: 'surface' | 'surfaceVariant' | 'blue' | 'danger';
}) => {
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };

    return (
        <Snackbar
            open={openSnack}
            autoHideDuration={3000}
            onClose={handleCloseSnack}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
            <div>
                <Alert severity={severity} sx={{ width: '100%' }}>
                    {children}
                </Alert>
            </div>
        </Snackbar>
    );
};

export default SnackbarAlert;
